// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__E3IeZ","footer":"ModalUpdate_footer__1jbmm"};